import { getDocs, collectionGroup, query, orderBy } from 'firebase/firestore';
import { firestore } from '~/firebase/init';

import { PLATFORM_ID } from '~/globalVariables';
import { Item, UniqItem } from '~/types/store/item';

export default async function getOrderCountInPlatform(): Promise<Array<UniqItem>> {
  const ref = collectionGroup(firestore, 'items');

  const items = await getDocs(query(ref, orderBy(`orderCountInPlatform.${PLATFORM_ID}`, 'desc')));

  return items.docs.map((doc) => ({
    id: doc.id,
    uniqId: `${doc.ref.parent.parent?.id || ''}${doc.id}`,
    storeId: doc.ref.parent.parent?.id || '',
    ...(doc.data() as Item),
  }));
}
